import type { PopulatedMenu, Menu } from 'root/apiTypes';

export const getMenusMap = <T extends PopulatedMenu | Menu>(menus: T[]) => {
  return menus.reduce((acc: Record<string, T>, menu) => ({ ...acc, [menu.id as string]: menu }), {});
};
